// @flow
import * as React from "react"
import { EventList } from "../EventList"
import { Link } from "react-static"
import { RouteData } from "react-static"
import { css } from "emotion"
import { Container } from "../StyledComponents"
import { color } from "../../styles/variables"

export function ActivitesAndEvents() {
  return (
    <RouteData>
      {(routeProps) =>
        routeProps.neon &&
        routeProps.neon.events &&
        routeProps.neon.events.events &&
        routeProps.neon.events.events.length > 0 ? (
          <div
            className={css`
              margin: 60px 0 0;
              border-bottom: 1px solid ${color.rgb.gray[2]};
              padding-bottom: 60px;
            `}
          >
            <Container>
              <h2>Activities &amp; Events</h2>
              <EventList
                items={routeProps.neon.events.events.filter(
                  (event, i) => i < 6,
                )}
              />
              <div
                className={css`
                  margin: 30px auto 0;
                  text-align: center;
                `}
              >
                <Link to="/events" className="btn btn-orange">
                  See All Events &amp; Activities
                </Link>
              </div>
            </Container>
          </div>
        ) : (
          <span />
        )
      }
    </RouteData>
  )
}



// WEBPACK FOOTER //
// /opt/build/repo/src/components/FlexibleContent/ActivitesAndEvents.js